import Axios from "axios"

export const getSites = (options={ small: false, latestImage: false, status: false, business: false }) => {
  return Axios.get('/sites', {
    params: {
      latestImage: options.latestImage,
      device: options.status,
      business: options.business
    }
  });
}

export const getBusinesses = () => {
  return Axios.get('/businesses');
}